import { apiClient } from "./apiClient.services";
import { showGlobalDialogError } from "../components/error";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const GetDailySummary = async (value) => {
	const { businessId } = getAuthData();

	return await apiClient(`/trans/daily-summary?upto=${value}${localStorage.getItem("businessId") ? `&businessId=${businessId}` : ''}`);
}

export const GetDailySummaryBalance = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/core/accounts/seller-balance-summary${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
	}
}